/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

interface Map {
  [key: string]: string | null
}

export const getOptimizelyVariationList = (map: Map) => {
  const variationList: string[] = []
  for (const [key, variation] of Object.entries(map)) {
    variation && variationList.push(`${key}:${variation}`)
  }
  return variationList
}
